export function filterProjectsByTag(projects, tag) {
    return projects.filter(project => (project.tags.includes(tag)));
}